export default {"src":"/_next/static/media/email.c455f243.svg","height":57,"width":56,"blurWidth":0,"blurHeight":0};